<template>
  <v-app>
    <home-app-bar />

    <home-view />

    <home-footer />
  </v-app>
</template>

<script>

  export default {
    name: 'HomeLayout',

    metaInfo () {
      return (this.dataConfig && this.dataLabels) && {
        title: this.dataConfig.m_title,
        htmlAttrs: { lang: 'en' },
        meta: [
          { charset: 'utf-8' },
          { name: 'viewport', content: 'width=device-width, initial-scale=1' },
          { name: 'description', content: this.dataConfig.m_description },
          { name: 'og:image', content: this.dataConfig.corp_logo }
        ]
      }
    },

    components: {
      HomeAppBar: () => import('./AppBar'),
      HomeFooter: () => import('./Footer'),
      HomeView: () => import('@/layouts/View')
    }

    // mounted () {
    //   document.getElementById('favicon').href = this.dataConfig.corp_logo
    // }
  }
</script>

<style lang="scss">
  @import '@/styles/mhr.scss';
</style>
